<table class="coming-free" *ngIf="rows && rows.length > 0">
  <thead>
    <tr>
      <th>{{ 'dashboard.team.member' | translate }}</th>
      <th>{{ 'dashboard.company.coming_free_col_free_from' | translate }}</th>
      <th>{{ 'dashboard.company.coming_free_col_util' | translate }}</th>
      <th>{{ 'dashboard.company.coming_free_col_project' | translate }}</th>
      <th>{{ 'dashboard.company.col_matches' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows" class="coming-free-row">
      <td class="name" [attr.data-label]="'dashboard.team.member' | translate"><button type="button" class="row-action" (click)="select(row)">{{ row.name }}</button></td>
      <td class="date" [attr.data-label]="'dashboard.company.coming_free_col_free_from' | translate">{{ row.freeFrom | date:'d MMM y' }}</td>
      <td class="util" [attr.data-label]="'dashboard.company.coming_free_col_util' | translate">{{ row.currentUtil !== null ? row.currentUtil + '%' : '—' }}</td>
      <td class="project" [attr.data-label]="'dashboard.company.coming_free_col_project' | translate">{{ row.lastProject }}</td>
      <td class="matches" [attr.data-label]="'dashboard.company.col_matches' | translate">
        <span class="match-chip" [class]="matchScoreBand(row.bestMatchScore)" *ngIf="row.matchCount > 0">
          {{ 'dashboard.company.match_count' | plural:row.matchCount | translate:{ value: row.matchCount, best: row.bestMatchScore } }}
        </span>
        <span *ngIf="row.matchCount === 0">—</span>
      </td>
    </tr>
  </tbody>
</table>
<p class="match-as-of" *ngIf="data?.matchAsOf">{{ 'dashboard.company.match_as_of' | translate:{ when: (data.matchAsOf | date:'d MMM, HH:mm') } }}</p>
